// src/hooks/useLang.js
import { useContext } from 'react';
import { LangContext } from '../context/LangContext';
import { translations } from '../i18n/translations';

export function useLang() {
  const ctx = useContext(LangContext);
  if (!ctx) throw new Error('useLang must be inside LangProvider');

  const { lang, setLang, t } = ctx;
  const dict = translations[lang];

  return { 
    language: lang, 
    setLanguage: setLang, 
    lang, 
    setLang, 
    t, 
    dict 
  };
}

export default useLang;
